import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, InspectorControls } from '@wordpress/block-editor';
import { useState, Fragment } from '@wordpress/element';
import { SelectControl, PanelBody } from '@wordpress/components';
import './style.scss';

registerBlockType('ps-s-custom-gutenberg-components/ps-s-accordion', {
    title: __( 'Accordion ( React version ) ', 'ps-s-custom-gutenberg-components' ),
    icon: 'menu',
    category: 'layout',
    attributes: {
        slides: {
            type: 'array',
            default: [{ id: 0, title: '', content: '' }],
        },
        tagName: {
            type: 'string',
            default: 'h2',
        },
    },
    edit: (props) => {
        const { attributes: { slides, tagName }, setAttributes } = props;

        const addSlide = () => {
            const newSlide = { id: slides.length, title: '', content: '' };
            setAttributes({ slides: [...slides, newSlide] });
        };

        const removeSlide = (id) => {
            setAttributes({ slides: slides.filter((slide) => slide.id !== id) });
        };

        const updateSlide = (id, field, value) => {
            setAttributes({ slides: slides.map((slide) => slide.id === id ? { ...slide, [field]: value } : slide) });
        };

        return (
            <Fragment>
                <InspectorControls>
                    <PanelBody title={ __( 'Accordion ettings' ) }>
                        <SelectControl
                            label="Select heading level"
                            value={tagName}
                            options={[
                                { label: 'Paragraph', value: 'p' },
                                { label: 'Heading 1', value: 'h1' },
                                { label: 'Heading 2', value: 'h2' },
                                { label: 'Heading 3', value: 'h3' },
                                { label: 'Heading 4', value: 'h4' },
                                { label: 'Heading 5', value: 'h5' },
                                { label: 'Heading 6', value: 'h6' },
                            ]}
                            onChange={(value) => setAttributes({ tagName: value })}
                        />
                    </PanelBody>
                </InspectorControls>
                <div className='ps-s-accordion-backend'>
                     {slides.map((slide) => ( 
                        <div className="slide" key={slide.id}>
                            <RichText
                                tagName={tagName}
                                value={slide.title}
                                onChange={(value) => updateSlide(slide.id, "title", value)}
                                placeholder="Enter title..."
                            />
                            <RichText
                                tagName="p"
                                value={slide.content}
                                onChange={(value) => updateSlide(slide.id, "content", value)}
                                placeholder="Enter content..."
                                multiline="p" // Enable line breaks
                            />
                            <button className="isSecondary" isSecondary onClick={() => removeSlide(slide.id)}>Delete Slide</button>
                        </div>
                     ))} 
                    <button className="isPrimary" isPrimary onClick={addSlide}>Add Slide</button>
                </div>
            </Fragment>
        );
    },
    save: (props) => {
        const { attributes: { slides, tagName } } = props;
        const blockProps = useBlockProps.save();
        // poc
        return (
            <div className='ps-s-accordion' {...blockProps}>
                {slides.map((slide, index) => (
                    <div className={"ps-s-accordion-slide-"+index} key={index}>
                        <div className='ps-s-accordion-heading'>
                        <RichText.Content tagName={tagName} value={slide.title} />
                        </div>
                        <div className='ps-s-accordion-content'>
                        <RichText.Content tagName="p" value={slide.content} />
                        </div>
                    </div>
                ))}
            </div>
        );
    },
});
